<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.variable}">
      <select :value="variable" name="variable" class="form-control" @change="handleChange">
        <option value="" selected="selected">
          Select a Variable
        </option>
        <optgroup v-for="(variables, type) in filteredStudyVariablesByType" :key="type" :label="getTypeDisplay(type)">
          <option v-for="($variable, $id) in variables" :key="$id" :value="$id">
            {{ $variable.name }}
          </option>
        </optgroup>
      </select>
    </div>
    <div v-if="variable">
      <div v-if="showComparatorChoices" :class="{'has-error':errors.comparator_choices}">
        is one of
        <div v-for="(value, key) in config.studyVariables[variable].options" :key="key">
          <input
            v-model="selectedComparatorChoices"
            :value="value.name"
            type="checkbox"
            name="comparator_choices"
          >
          <label>{{ value.name }}</label>
        </div>
      </div>
      <div v-else>
        <span :class="{'has-error':errors.operator}">
          <select
            :value="operator"
            name="operator"
            class="form-control selectpicker"
            @input="handleChange"
          >
            <option value="" selected="selected">Select Operator</option>
            <optgroup label="All">
              <option value="isNull">Is null</option>
              <option value="isNotNull">Is not null</option>
              <option value="textEmpty">Is Empty</option>
              <option value="textNotEmpty">Is Not Empty</option>
            </optgroup>
            <optgroup v-if="showNumericOperators" label="Numeric">
              <option value="lt">&lt;</option>
              <option value="lte">≤</option>
              <option value="gt">&gt;</option>
              <option value="gte">≥</option>
              <option value="eq">=</option>
              <option value="neq">≠</option>
            </optgroup>
            <optgroup v-if="showTextOperators" label="Text">
              <option value="contains">Contains</option>
              <option value="doesNotContain">Does Not Contain</option>
              <option value="startsWith">Starts With</option>
              <option value="endsWith">Ends With</option>
              <option value="textEquals">Equals</option>
              <option value="textDoesNotEqual">Does Not Equal</option>
            </optgroup>
          </select>
        </span>
        <span v-if="operator && operatorTakesArgs">
          <select
            :value="comparator_type"
            name="comparator_type"
            class="form-control"
            @change="handleChange"
          >
            <option v-if="operatorIsNumeric" value="amount">Exact Amount</option>
            <option v-if="!operatorIsNumeric" value="text">Text Input</option>
            <option value="variable">Variable Value</option>
          </select>
          <span v-if="comparator_type == 'amount'" :class="{'has-error':errors.comparator}">
            <input
              :value="comparator"
              name="comparator"
              class="form-control input-numeric"
              @input="handleChange"
            >
          </span>
          <span v-else-if="comparator_type == 'text'" :class="{'has-error':errors.comparator}">
            <input
              :value="comparator"
              name="comparator"
              class="form-control"
              placeholder="Text Input"
              @input="handleChange"
            >
          </span>
          <span v-else-if="comparator_type == 'variable'" :class="{'has-error':errors.comparator}">
            <select :value="comparator" name="comparator" class="form-control" @change="handleChange">
              <option value="" selected="selected">Select a variable</option>
              <optgroup v-for="(variables, type) in filteredStudyVariablesByType" :key="type" :label="getTypeDisplay(type)">
                <option v-for="($variable, $id) in variables" :key="$id" :value="$id">
                  {{ $variable.name }}
                </option>
              </optgroup>
            </select>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';
  import { nonNumericOperators, unaryOperators } from "@/EventLogic/operators";

  export default {
    extends: BaseComponent,

    props: {
      variable: [Number, String],
      comparator_type: {
        type: String,
        default: 'amount'
      },
      comparator: String,
      operator: String,
      comparator_choices: {
        type: Array,
        default: () => []
      },
      id: String,
    },
    data: function () {
      return {
        selectedComparatorChoices: this.comparator_choices,
      }
    },
    computed: {
      filteredStudyVariablesByType: function () {
        let studyVariablesByTypeCopy = {};
        for (let key in this.config.studyVariablesByType) {
          studyVariablesByTypeCopy[key] = this.config.studyVariablesByType[key];
        }
        return studyVariablesByTypeCopy;
      },
      showNumericOperators: function() {
        if (this.config.studyVariables[this.variable]) {
          return this.config.studyVariables[this.variable].is_numeric;
        }

        return false;
      },
      showTextOperators: function() {
        if (this.config.studyVariables[this.variable]) {
          return this.config.studyVariables[this.variable].is_text;
        }

        return false;
      },
      showComparatorChoices: function() {
        if (this.config.studyVariables[this.variable]) {
          return this.config.studyVariables[this.variable].is_multiple_choice;
        }

        return false;
      },
      operatorIsNumeric: function() {
        return nonNumericOperators.includes(this.operator) === false;
      },
      operatorTakesArgs: function() {
        return unaryOperators.includes(this.operator) === false;
      }
    },
    watch: {
      'variable': function(val, oldVal) {
        if (val != oldVal) {
          this.$emit('update:operator', '');
        }
      },
      'operatorIsNumeric': function(val, oldval) {
        if (val) {
          this.$emit('update:comparator_type', 'amount');
        } else {
          if (this.operatorTakesArgs) {
            this.$emit('update:comparator_type', 'text');
          } else {
            this.$emit('update:comparator_type', '');
          }
        }
      },
      'operatorTakesArgs': function(val, oldval) {
        if (!val) {
          this.$emit('update:comparator_type', '');
          this.$emit('update:comparator', '');
        }
      },
      'comparator_type': function(val, oldVal) {
        this.$emit('update:comparator', undefined);
      },
      showComparatorChoices: function (val) {
        if (val) {
          this.$emit('update:comparator_type', 'multiple_choice');
          this.$emit('update:operator', 'isOneOf');
        } else {
          this.$emit('update:comparator_type', '');
          this.$emit('update:operator', '');
        }
      },
      selectedComparatorChoices: function() {
        this.$emit('update:comparator_choices', this.selectedComparatorChoices);
      },
      comparator_choices: function(value) {
        this.selectedComparatorChoices = value;
      },
    },
    methods: {
      getTypeDisplay: function(type) {
        return this.config.studyVariableTypeDisplayMap[type];
      },
      validate: function() {
        this.errors = {};
        if (!this.variable) {
          this.errors.variable = 'Please select a Variable.';
        } else {
          if (!this.operator) {
            this.errors.operator = "Please select a comparison operator.";
          }

          if (this.operatorTakesArgs) {
            if (this.showComparatorChoices) {
              if (this.comparator_choices.length < 1) {
                this.errors.comparator_choices = "Please select at least one valid choice.";
              }
            } else if (!this.comparator) {
              this.errors.comparator = "Please select something to compare against.";
            }
          }
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
